import Chart from 'react-apexcharts';
import { useState } from 'react';
import { Button, Modal } from 'antd';
import { FullscreenOutlined } from '@ant-design/icons';
import { addSeparators } from '../../utils/format-utils.js';

function BarChart({ series, options, stacked = false, title }) {
  const _options = {
    chart: {
      type: 'bar',
      height: 350,
      stacked,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      theme: 'dark',
      fixed: {
        enabled: true,
        position: 'topRight',
      },
    },
  };
  const [open, setOpen] = useState(false);

  let combinedOptions = {
    ..._options,
    ...options,
  };

  combinedOptions = {
    ...combinedOptions,
    xaxis: {
      ...combinedOptions.xaxis,
      labels: {
        formatter: (value) => addSeparators(value),
        style: {
          colors: 'white',
        },
      },
    },
    yaxis: {
      ...combinedOptions.yaxis,
      labels: {
        formatter: (value) => value,
        style: {
          colors: 'white',
        },
      },
    },
    legend: {
      labels: {
        colors: 'white',
      },
    },
  };

  const chart = (
    <Chart options={combinedOptions} series={series} type="bar" height={350} />
  );

  const chartModal = (
    <Chart options={combinedOptions} series={series} type="bar" />
  );

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          columnGap: '10px',
        }}
      >
        <div
          style={{
            fontSize: 14,
            fontWeight: 900,
            color: 'white',
            width: 'calc(100% - 42px)',
          }}
        >
          {title}
        </div>
        <Button
          className="glass"
          icon={<FullscreenOutlined />}
          onClick={() => setOpen(true)}
        />
      </div>
      {chart}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width="70vw"
        classNames={{
          content: 'glass',
        }}
      >
        {chartModal}
      </Modal>
    </div>
  );
}

export default BarChart;
